/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*-----------------------------------------------------------------------------
  Custom Theme JS — Loopr
-----------------------------------------------------------------------------*/

/*-----------------------------------------------------------------------------
  Custom Theme JS — Loopr
-----------------------------------------------------------------------------*/

const categoryParentUrls = {
  'Bord': '/collections/bord',
  'Sittemøbler': '/collections/sittemobler',
  'Oppbevaring': '/collections/oppbevaring',
  'Lyddemping og skjerming': '/collections/lyddemping-og-skjerming',
  'Kontortilbehør': '/collections/kontortilbehor',
};

const categoryTree = {
  'Sittemøbler': [
    { label: 'Konferansestoler', url: '/collections/konferansestoler' },
    { label: 'Kontorstoler', url: '/collections/kontorstoler-1' },
    { label: 'Besøksstoler', url: '/collections/besoksstoler-1' },
    { label: 'Lenestoler', url: '/collections/lenestol-1' },
    { label: 'Spisestoler', url: '/collections/spisestoler-1' },
    { label: 'Barkrakker', url: '/collections/barkrakk-1' },
    { label: 'Loungemøbler', url: '/collections/loungemobler' },
    { label: 'Alkovesofaer og workpods', url: '/collections/alkovesofaer-og-workpods-1' },
    { label: 'Sofa', url: '/collections/sofa-1' },
    { label: 'Puffer', url: '/collections/puffer-1' },
  ],
  'Bord': [
    { label: 'Barbord', url: '/collections/barbord-1' },
    { label: 'Møtebord', url: '/collections/motebord-1' },
    { label: 'Skrivebord', url: '/collections/skrivebord-1' },
    { label: 'Lounge- og avlastningsbord', url: '/collections/lounge-sofa-og-avlastningsbord' },
    { label: 'Spisebord', url: '/collections/klappbord-1' },
  ],
  'Oppbevaring': [
    { label: 'Tårnskap', url: '/collections/tarnskap-1' },
    { label: 'Kontorskap', url: '/collections/kontorskap' },
    { label: 'Hyller', url: '/collections/hyller-1' },
    { label: 'Skuffeseksjoner', url: '/collections/skuffeseksjoner-v2' },
    { label: 'Stumtjenere', url: '/collections/stumtjenere' },
  ],
  'Lyddemping og skjerming': [
    { label: 'Bordskjermer', url: '/collections/bordskjermer' },
    { label: 'Skillevegger', url: '/collections/skillevegger' },
    { label: 'Lydabsorbenter', url: '/collections/lydabsorbenter-1' },
  ],
  'Kontortilbehør': [
    { label: 'Belysning', url: '/collections/belysning' },
    { label: 'Whiteboards og tavler', url: '/collections/whiteboards-og-tavler-1' },
  ],
};

const colorMap = {
  'beige': '#f5f0dc', 'blå': '#4a90d9', 'brun': '#8B5E3C',
  'grå': '#9e9e9e', 'grønn': '#4caf50', 'gul': '#fdd835',
  'hvit': '#ffffff', 'lilla': '#9c27b0', 'oransje': '#ff9800',
  'rosa': '#f48fb1', 'rosegull': '#e8b4a0', 'rød': '#f44336',
  'sort': '#212121', 'sølv': '#c0c0c0', 'flerfarget': null
};

// ── Color dots ────────────────────────────────
function addColorDots() {
  document.querySelectorAll('.collection-sidebar__item').forEach(item => {
    if (item.dataset.dotAdded) return;
    const label = item.querySelector('label');
    if (!label) return;
    const textNode = Array.from(label.childNodes)
      .find(n => n.nodeType === 3 && n.textContent.trim().length > 0);
    if (!textNode) return;
    const text = textNode.textContent.trim().toLowerCase();
    if (!colorMap.hasOwnProperty(text)) return;
    item.dataset.dotAdded = 'true';
    const dot = document.createElement('span');
    const bg = colorMap[text];
    dot.style.cssText = `
      display:inline-block;width:14px;height:14px;border-radius:50%;
      background:${bg || 'linear-gradient(135deg,red,blue,green,yellow)'};
      margin-right:8px;vertical-align:middle;
      border:1px solid rgba(0,0,0,0.15);flex-shrink:0;
    `;
    label.insertBefore(dot, textNode);
  });
}

// Cache all dimension values on first page load
window.looprDimValues = window.looprDimValues || {};

function cacheDimensionValues() {
  document.querySelectorAll('.collection-sidebar__filter-group').forEach(group => {
    const firstInput = group.querySelector('input[type="checkbox"]');
    if (!firstInput) return;
    const paramName = firstInput.name;
    if (!paramName.includes('m.custom')) return;

    const values = Array.from(group.querySelectorAll('input[type="checkbox"]'))
      .map(i => parseFloat(i.value))
      .filter(v => !isNaN(v));

    // Only update cache if we have MORE values than before
    if (!window.looprDimValues[paramName] || values.length > window.looprDimValues[paramName].length) {
      window.looprDimValues[paramName] = values;
    }
  });
}

// ── Replace dimension list filters with input fields ──
function replaceDimensionFilters() {
  if (document.activeElement?.classList.contains('loopr-dim-input')) return;

  document.querySelectorAll('.collection-sidebar__filter-group').forEach(group => {
    if (group.querySelector('.loopr-dim-apply')) return;

    const summary = group.querySelector('summary span');
    if (!summary) return;
    const label = summary.textContent.trim().toLowerCase();

    const isDimension = label.includes('høyde') || label.includes('bredde') || label.includes('dybde') || label.includes('(cm)');
    if (!isDimension) return;

    const firstInput = group.querySelector('input[type="checkbox"]');
    if (!firstInput) return;

    const paramName = firstInput.name;

    // Cache all values globally before replacing
    const freshValues = Array.from(group.querySelectorAll('input[type="checkbox"]'))
      .map(i => parseFloat(i.value))
      .filter(v => !isNaN(v));
    if (!window.looprDimValues) window.looprDimValues = {};
    if (!window.looprDimValues[paramName] || freshValues.length > window.looprDimValues[paramName].length) {
      window.looprDimValues[paramName] = freshValues;
    }

    // Read current active values from URL to restore input display
    const urlParams = new URLSearchParams(window.location.search);
    const activeValues = urlParams.getAll(paramName).map(v => parseFloat(v)).filter(v => !isNaN(v));
    const currentMin = activeValues.length > 0 ? Math.min(...activeValues) : '';
    const currentMax = activeValues.length > 0 ? Math.max(...activeValues) : '';

    const accordion = group.querySelector('details-content');
    if (!accordion) return;

    accordion.innerHTML = `
      <div style="padding:12px 0;">
        <div style="display:flex;gap:8px;align-items:center;">
          <input
            type="number"
            placeholder="Fra cm"
            value="${currentMin}"
            class="loopr-dim-input loopr-dim-min"
            style="width:100%;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;font-family:inherit;"
          />
          <span style="color:#999;">–</span>
          <input
            type="number"
            placeholder="Til cm"
            value="${currentMax}"
            class="loopr-dim-input loopr-dim-max"
            style="width:100%;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;font-family:inherit;"
          />
        </div>
        <button
          class="loopr-dim-apply"
          style="
            margin-top:10px;width:100%;padding:8px;
            background:#102c24;color:#fff;border:none;
            border-radius:6px;font-size:13px;cursor:pointer;
            font-family:inherit;font-weight:600;
          "
        >Bruk filter</button>
      </div>
    `;

    // Stop events bubbling to filter form
    group.querySelectorAll('.loopr-dim-input').forEach(input => {
      ['click', 'focus', 'change', 'input', 'keydown', 'keyup', 'mousedown', 'mouseup'].forEach(evt => {
        input.addEventListener(evt, e => e.stopPropagation());
      });
    });

    // Apply button
    group.querySelector('.loopr-dim-apply').addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      const minVal = parseFloat(group.querySelector('.loopr-dim-min').value);
      const maxVal = parseFloat(group.querySelector('.loopr-dim-max').value);

      const url = new URL(window.location.href);
      url.searchParams.delete(paramName);

      // Use globally cached values for this param
      const allValues = window.looprDimValues[paramName] || [];

      const hasMin = !isNaN(minVal);
      const hasMax = !isNaN(maxVal);

      allValues.forEach(val => {
        const aboveMin = !hasMin || val >= minVal;
        const belowMax = !hasMax || val <= maxVal;
        if (aboveMin && belowMax) {
          url.searchParams.append(paramName, val);
        }
      });

      window.location.href = url.toString();
    });
  });
}

function enhanceBrandFilter() {
  document.querySelectorAll('.collection-sidebar__filter-group').forEach(group => {
    if (group.dataset.brandEnhanced) return;

    const summary = group.querySelector('summary span');
    if (!summary) return;
    const label = summary.textContent.trim().toLowerCase();
    if (!label.includes('merkevare') && !label.includes('brand') && !label.includes('vendor')) return;

    group.dataset.brandEnhanced = 'true';

    const accordion = group.querySelector('details-content');
    if (!accordion) return;

    const items = Array.from(accordion.querySelectorAll('li.collection-sidebar__item'));
    if (items.length === 0) return;

    const SHOW_COUNT = 10;

    // Add search input above the list
    const searchDiv = document.createElement('div');
    searchDiv.style.cssText = 'padding:8px 0 4px 0;';
    searchDiv.innerHTML = `
      <input
        type="text"
        class="loopr-brand-search"
        placeholder="Søk merke..."
        style="width:100%;padding:8px 10px;border:1px solid #ddd;border-radius:6px;
               font-size:13px;font-family:inherit;outline:none;box-sizing:border-box;"
      />
    `;
    accordion.insertBefore(searchDiv, accordion.firstChild);

    // Stop events bubbling to filter form
    const brandSearchInput = searchDiv.querySelector('.loopr-brand-search');
    ['click', 'focus', 'change', 'input', 'keydown', 'keyup', 'mousedown'].forEach(evt => {
      brandSearchInput.addEventListener(evt, e => e.stopPropagation());
    });

    // Hide items beyond SHOW_COUNT initially
    items.forEach((item, idx) => {
      if (idx >= SHOW_COUNT) item.style.display = 'none';
      item.dataset.brandIndex = idx;
    });

    // Add expand button if more than SHOW_COUNT
    if (items.length > SHOW_COUNT) {
      const expandBtn = document.createElement('button');
      expandBtn.className = 'loopr-brand-expand';
      expandBtn.textContent = `••• Vis alle (${items.length})`;
      expandBtn.style.cssText = `
        background:none;border:none;color:#0c5832;font-size:13px;
        cursor:pointer;padding:8px 0 4px 0;font-family:inherit;
        font-weight:600;text-decoration:underline;display:block;
      `;

      let expanded = false;
      expandBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        expanded = !expanded;
        items.forEach((item, idx) => {
          if (idx >= SHOW_COUNT) {
            item.style.display = expanded ? '' : 'none';
          }
        });
        expandBtn.textContent = expanded
          ? '••• Vis færre'
          : `••• Vis alle (${items.length})`;
      });

      accordion.appendChild(expandBtn);
    }

    // Wire up brand search
    brandSearchInput.addEventListener('input', function() {
      const query = this.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach(item => {
        const text = item.querySelector('label')?.textContent.trim().toLowerCase() || '';
        const matches = !query || text.includes(query);
        item.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      // Hide/show expand button during search
      const expandBtn = accordion.querySelector('.loopr-brand-expand');
      if (expandBtn) expandBtn.style.display = query ? 'none' : '';
    });
  });
}

function initPriceToggle() {
  const toggle = document.getElementById('loopr-price-toggle');
  const track = document.getElementById('loopr-toggle-track');
  if (!toggle || !track) return;

  let mode = localStorage.getItem('loopr-pricing') || 'b2b';

  function applyPricing(m) {
    mode = m;
    localStorage.setItem('loopr-pricing', m);

    // Update prices
    document.querySelectorAll('[data-b2b][data-b2c]').forEach(el => {
      el.textContent = m === 'b2b' ? el.dataset.b2b : el.dataset.b2c;
      el.dataset.pricing = m;
    });

    // Update toggle appearance
    const labels = toggle.querySelectorAll('.loopr-price-toggle__label');
    if (m === 'b2b') {
      toggle.classList.remove('loopr-price-toggle--privat');
      labels[0]?.classList.add('loopr-price-toggle__label--active');
      labels[1]?.classList.remove('loopr-price-toggle__label--active');
    } else {
      toggle.classList.add('loopr-price-toggle--privat');
      labels[0]?.classList.remove('loopr-price-toggle__label--active');
      labels[1]?.classList.add('loopr-price-toggle__label--active');
    }
  }

  track.addEventListener('click', () => applyPricing(mode === 'b2b' ? 'b2c' : 'b2b'));
  applyPricing(mode);
}

function enhanceCategoryFilter() {
  // Hide the native Produkttype filter group from Search & Discovery
  document.querySelectorAll('.collection-sidebar__filter-group').forEach(function(group) {
    var summary = group.querySelector('summary span');
    if (!summary) return;
    var groupLabel = summary.textContent.trim();
    if (groupLabel === 'Produkttype' || groupLabel === 'Produkter' || groupLabel === 'Product type') {
      group.style.display = 'none';
    }
  });

  if (document.getElementById('loopr-category-tree')) return;

  var sidebar = document.querySelector('.collection-sidebar__wrapper');
  if (!sidebar) return;

  // Read collection product counts from Liquid-generated JSON
  var looprCollectionCounts = {};
  try {
    var countsEl = document.getElementById('loopr-collection-counts');
    if (countsEl) {
      looprCollectionCounts = JSON.parse(countsEl.textContent);
    }
  } catch(e) {}

  var currentPath = window.location.pathname.replace(/\/$/, '');

  var treeWrapper = document.createElement('div');
  treeWrapper.id = 'loopr-category-tree';
  treeWrapper.style.cssText = 'margin-bottom:20px;';

  var header = document.createElement('div');
  header.style.cssText = '\
    display:flex;align-items:center;justify-content:space-between;\
    padding:10px 0;border-bottom:1px solid #e8e4db;margin-bottom:4px;\
    cursor:default;\
  ';
  header.innerHTML = '<span style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:14px;font-weight:700;color:#102c24;">Produkttype</span>';
  treeWrapper.appendChild(header);

  var listContainer = document.createElement('div');
  listContainer.id = 'loopr-category-tree-list';

  // Detect active parent/sub from URL
  var activeParent = null;
  var activeSubUrl = null;
  Object.keys(categoryTree).forEach(function(parentLabel) {
    // Check parent URL
    var parentUrl = categoryParentUrls[parentLabel];
    if (parentUrl && currentPath === parentUrl.replace(/\/$/, '')) {
      activeParent = parentLabel;
    }
    // Check sub URLs
    categoryTree[parentLabel].forEach(function(sub) {
      if (currentPath === sub.url.replace(/\/$/, '')) {
        activeParent = parentLabel;
        activeSubUrl = sub.url;
      }
    });
  });

  Object.keys(categoryTree).forEach(function(parentLabel) {
    var parentUrl = categoryParentUrls[parentLabel] || '#';
    var isParentActive = activeParent === parentLabel;
    var isParentExactMatch = currentPath === parentUrl.replace(/\/$/, '');

    var parentDiv = document.createElement('div');
    parentDiv.className = 'loopr-cat-parent';

    // Parent row: clickable link + toggle chevron
    var parentRow = document.createElement('div');
    parentRow.style.cssText = '\
      display:flex;align-items:center;gap:0;\
      position:relative;\
    ';

    // The category link (takes most of the row)
    var parentLink = document.createElement('a');
    parentLink.href = parentUrl;
    parentLink.className = 'loopr-cat-parent-link';
    parentLink.style.cssText = '\
      display:flex;align-items:center;gap:8px;flex:1;\
      padding:9px 12px;border-radius:100px;\
      font-family:inherit;font-size:14px;text-decoration:none;\
      color:#102c24;\
      font-weight:' + (isParentActive ? '700' : '500') + ';\
      background:' + (isParentExactMatch ? 'rgba(70,230,150,0.3)' : 'transparent') + ';\
      transition:background 0.15s;\
    ';

    var parentLabelSpan = document.createElement('span');
    parentLabelSpan.textContent = parentLabel;
    parentLink.appendChild(parentLabelSpan);

    // Parent count from Liquid
    var parentCount = looprCollectionCounts[parentUrl];
    if (parentCount !== undefined) {
      var countSpan = document.createElement('span');
      countSpan.textContent = '(' + parentCount + ')';
      countSpan.style.cssText = 'font-weight:400;color:#777;font-size:13px;';
      parentLink.appendChild(countSpan);
    }

    if (!isParentExactMatch) {
      parentLink.addEventListener('mouseover', function() {
        this.style.background = 'rgba(70,230,150,0.12)';
      });
      parentLink.addEventListener('mouseout', function() {
        this.style.background = 'transparent';
      });
    }

    // Chevron toggle button (separate from the link)
    var chevronBtn = document.createElement('button');
    chevronBtn.className = 'loopr-cat-chevron-btn';
    chevronBtn.setAttribute('aria-label', 'Vis underkategorier');
    chevronBtn.style.cssText = '\
      display:inline-flex;align-items:center;justify-content:center;\
      width:32px;height:32px;flex-shrink:0;\
      background:none;border:none;cursor:pointer;\
      border-radius:50%;transition:background 0.15s;\
    ';
    chevronBtn.innerHTML = '<svg class="loopr-cat-chevron-svg" width="14" height="14" viewBox="0 0 12 12" fill="none" style="transition:transform 0.2s ease;' + (isParentActive ? 'transform:rotate(90deg);' : '') + '"><path d="M4 2l4 4-4 4" stroke="#102c24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    chevronBtn.addEventListener('mouseover', function() {
      this.style.background = 'rgba(16,44,36,0.08)';
    });
    chevronBtn.addEventListener('mouseout', function() {
      this.style.background = 'none';
    });

    parentRow.appendChild(parentLink);
    parentRow.appendChild(chevronBtn);
    parentDiv.appendChild(parentRow);

    // Subcategory list
    var subList = document.createElement('div');
    subList.className = 'loopr-cat-sublist';
    subList.style.cssText = '\
      padding:2px 0 6px 16px;overflow:hidden;\
      display:' + (isParentActive ? 'block' : 'none') + ';\
    ';

    categoryTree[parentLabel].forEach(function(sub) {
      var subPath = sub.url.replace(/\/$/, '');
      var isSubActive = currentPath === subPath;

      var subLink = document.createElement('a');
      subLink.href = sub.url;
      subLink.className = 'loopr-cat-sublink';
      subLink.style.cssText = '\
        display:flex;align-items:center;gap:6px;\
        padding:6px 12px;margin:2px 0;border-radius:100px;\
        text-decoration:none;font-family:inherit;font-size:13px;\
        font-weight:' + (isSubActive ? '600' : '500') + ';\
        color:#102c24;\
        background:' + (isSubActive ? 'rgba(70,230,150,0.3)' : 'transparent') + ';\
        transition:background 0.15s;\
      ';

      var subLabelSpan = document.createElement('span');
      var subCount = looprCollectionCounts[sub.url];
      subLabelSpan.textContent = sub.label + (subCount !== undefined ? ' (' + subCount + ')' : '');

      subLink.appendChild(subLabelSpan);

      if (!isSubActive) {
        subLink.addEventListener('mouseover', function() {
          this.style.background = 'rgba(70,230,150,0.12)';
        });
        subLink.addEventListener('mouseout', function() {
          this.style.background = 'transparent';
        });
      }

      subList.appendChild(subLink);
    });

    parentDiv.appendChild(subList);

    // Chevron toggles the subcategory list (doesn't navigate)
    chevronBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = subList.style.display !== 'none';
      subList.style.display = isOpen ? 'none' : 'block';
      var svg = this.querySelector('.loopr-cat-chevron-svg');
      if (svg) svg.style.transform = isOpen ? '' : 'rotate(90deg)';
    });

    listContainer.appendChild(parentDiv);
  });

  treeWrapper.appendChild(listContainer);

  var searchInput = sidebar.querySelector('#loopr-product-search');
  var searchDiv = searchInput ? searchInput.closest('div') : null;
  if (searchDiv && searchDiv.parentNode === sidebar) {
    sidebar.insertBefore(treeWrapper, searchDiv.nextSibling);
  } else {
    sidebar.insertBefore(treeWrapper, sidebar.firstChild);
  }
}

// ── Search bar ────────────────────────────────
function addFilterSearch() {
  if (document.getElementById('loopr-product-search')) return;

  const sidebar = document.querySelector('.collection-sidebar__wrapper');
  if (!sidebar) return;

  const searchDiv = document.createElement('div');
  searchDiv.style.cssText = 'padding:0 0 8px 0;';
  searchDiv.innerHTML = `
    <form action="/search" method="get" class="loopr-search-form" style="display:flex;gap:6px;">
      <input type="hidden" name="type" value="product" />
      <input
        type="text"
        id="loopr-product-search"
        name="q"
        placeholder="Søk etter produkt..."
        style="width:100%;padding:10px 14px;border:1px solid #ddd;border-radius:8px;
               font-size:14px;font-family:inherit;outline:none;box-sizing:border-box;
               background:#fff;"
      />
      <button type="submit" style="
        background:#102c24;color:#fff;border:none;border-radius:8px;
        padding:0 14px;cursor:pointer;flex-shrink:0;display:flex;
        align-items:center;justify-content:center;height:48px;
      " aria-label="Søk">
        <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
        </svg>
      </button>
    </form>
  `;
  sidebar.insertBefore(searchDiv, sidebar.firstChild);
}

function initSearchPageEmptyState() {
  if (!window.location.pathname.includes('/search')) return;
  if (document.getElementById('loopr-no-results-search')) return;

  // Target the info div that shows "Ingen resultater for"
  const infoDiv = document.querySelector('.search-page__info');
  if (!infoDiv) return;

  // Hide the default text
  const infoText = infoDiv.querySelector('.search-page__info__text');
  if (infoText) infoText.style.display = 'none';

  // Only show our state if it's actually a no-results page
  // (check URL has ?q= and there are no product cards)
  const hasQuery = window.location.search.includes('q=');
  const hasProducts = document.querySelectorAll('product-card, .product-card').length > 0;
  if (!hasQuery || hasProducts) return;

  const emptyState = document.createElement('div');
  emptyState.id = 'loopr-no-results-search';
  emptyState.innerHTML = `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;padding:40px 20px;text-align:center;">
      <div style="font-family:'Plus Jakarta Sans',sans-serif;font-size:22px;font-weight:700;color:#102c24;margin-bottom:12px;">
        <strong>Ups, der var vi tomme</strong>
      </div>
      <div style="font-family:'Plus Jakarta Sans',sans-serif;font-size:16px;color:#555;margin-bottom:24px;">
        Prøv igjen senere. Nye varer hver uke;)
      </div>
      <img
        src="https://cdn.shopify.com/s/files/1/0692/2299/0124/files/Comp_1_1.gif?v=1774293425"
        alt="Ingen produkter funnet"
        style="width:320px;max-width:80%;height:auto;margin:0 auto 32px;"
        loading="lazy"
      >
      <a href="https://www.loopr.no/kontakt" style="
        background-color:#102c24;color:#fff;
        border-radius:100px;height:52px;padding:0 32px;
        font-family:'Plus Jakarta Sans',sans-serif;
        font-size:15px;font-weight:700;text-decoration:none;
        display:inline-flex;align-items:center;justify-content:center;
      ">Kontakt møbelrådgiver</a>
    </div>
  `;

  // Insert after the info div, inside the container
  infoDiv.parentNode.insertBefore(emptyState, infoDiv.nextSibling);
}


function looprOpenCartDrawer() {
  // Remove existing overlay if any
  var existingOverlay = document.getElementById('loopr-cart-overlay');
  if (existingOverlay) existingOverlay.remove();

  // Create overlay backdrop
  var overlay = document.createElement('div');
  overlay.id = 'loopr-cart-overlay';
  overlay.style.cssText = '\
    position:fixed;top:0;left:0;right:0;bottom:0;\
    background:rgba(0,0,0,0.5);z-index:9998;\
    opacity:0;transition:opacity 0.3s ease;\
  ';
  document.body.appendChild(overlay);

  // Create or reuse drawer
  var draw = document.getElementById('loopr-cart-drawer');
  if (!draw) {
    draw = document.createElement('div');
    draw.id = 'loopr-cart-drawer';
    document.body.appendChild(draw);
  }

  draw.style.cssText = '\
    display:block;position:fixed;top:0;right:-480px;\
    z-index:9999;background:#fefefe;\
    box-shadow:-4px 0 24px rgba(0,0,0,0.15);\
    max-width:480px;width:100%;height:100vh;\
    overflow-y:auto;\
    transition:right 0.3s ease;\
  ';

  // Show loading state
  draw.innerHTML = '\
    <div style="padding:24px;display:flex;justify-content:space-between;align-items:center;">\
      <h2 style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:22px;font-weight:700;color:#102c24;margin:0;">Handlekurv</h2>\
      <button id="loopr-cart-drawer-close" style="background:none;border:none;cursor:pointer;padding:8px;">\
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#102c24" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>\
      </button>\
    </div>\
    <div style="padding:24px;text-align:center;color:#777;">Laster...</div>\
  ';

  // Animate in
  requestAnimationFrame(function() {
    overlay.style.opacity = '1';
    draw.style.right = '0';
  });

  // Close function
  function closeDrawer() {
    draw.style.right = '-480px';
    overlay.style.opacity = '0';
    setTimeout(function() {
      draw.style.display = 'none';
      overlay.remove();
    }, 300);
  }

  overlay.addEventListener('click', closeDrawer);
  draw.querySelector('#loopr-cart-drawer-close').addEventListener('click', closeDrawer);

  var escHandler = function(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      document.removeEventListener('keydown', escHandler);
    }
  };
  document.addEventListener('keydown', escHandler);

  // Fetch full cart data and build drawer content
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var itemsHtml = '';

      cart.items.forEach(function(item) {
        var imgSrc = item.featured_image ? item.featured_image.url + '&width=120' : '';
        var price = (item.final_line_price / 100).toLocaleString('nb-NO') + ' NOK';
        var originalPrice = '';
        if (item.original_line_price > item.final_line_price) {
          // .money => picked up by loopr-dual-price.js (eks./ink. mva)
          originalPrice = '<span class="money loopr-drawer-compare" style="text-decoration:line-through;color:#999;font-size:13px;margin-left:8px;">' + (item.original_line_price / 100).toLocaleString('nb-NO') + ' NOK</span>';
        }
        var variantTitle = item.variant_title && !item.variant_title.includes('Default') ? '<div style="font-size:12px;color:#777;margin-top:2px;">' + item.variant_title + '</div>' : '';

        itemsHtml += '\
          <div class="loopr-drawer-item" style="display:flex;gap:16px;padding:16px 24px;border-bottom:1px solid #eee;">\
            <div style="width:80px;height:80px;flex-shrink:0;background:#f0ede6;border-radius:8px;overflow:hidden;display:flex;align-items:center;justify-content:center;">\
              ' + (imgSrc ? '<img src="' + imgSrc + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : '') + '\
            </div>\
            <div style="flex:1;min-width:0;">\
              <div style="font-size:12px;color:#777;">' + item.vendor + '</div>\
              <div style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:14px;font-weight:600;color:#102c24;margin-top:2px;">' + item.product_title + '</div>\
              ' + variantTitle + '\
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px;">\
                <div style="display:flex;align-items:center;gap:0;border:1px solid #ddd;border-radius:6px;overflow:hidden;">\
                  <button class="loopr-drawer-qty" data-key="' + item.key + '" data-action="minus" style="width:32px;height:32px;background:none;border:none;cursor:pointer;font-size:16px;color:#102c24;">−</button>\
                  <span style="width:32px;text-align:center;font-size:14px;font-weight:600;">' + item.quantity + '</span>\
                  <button class="loopr-drawer-qty" data-key="' + item.key + '" data-action="plus" data-qty="' + item.quantity + '" style="width:32px;height:32px;background:none;border:none;cursor:pointer;font-size:16px;color:#102c24;">+</button>\
                </div>\
                <div style="display:flex;align-items:center;">\
                  <span class="money loopr-drawer-price" style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:14px;font-weight:700;color:#102c24;">' + price + '</span>\
                  ' + originalPrice + '\
                </div>\
              </div>\
            </div>\
            <button class="loopr-drawer-remove" data-key="' + item.key + '" style="background:none;border:none;cursor:pointer;padding:4px;align-self:flex-start;flex-shrink:0;">\
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14"/></svg>\
            </button>\
          </div>\
        ';
      });

      var totalPrice = (cart.total_price / 100).toLocaleString('nb-NO') + ' NOK';

      draw.innerHTML = '\
        <div style="padding:20px 24px;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #eee;">\
          <h2 style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:22px;font-weight:700;color:#102c24;margin:0;">Handlekurv <span style="font-weight:400;color:#777;">(' + cart.item_count + ')</span></h2>\
          <button id="loopr-cart-drawer-close" style="background:none;border:none;cursor:pointer;padding:8px;">\
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#102c24" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>\
          </button>\
        </div>\
        <div id="loopr-drawer-items" style="flex:1;overflow-y:auto;">' + itemsHtml + '</div>\
        <div style="padding:16px 24px;border-top:1px solid #eee;">\
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;">\
            <span style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:16px;font-weight:700;color:#102c24;">Delsum</span>\
            <span class="money loopr-drawer-total" style="font-family:\'Plus Jakarta Sans\',sans-serif;font-size:16px;font-weight:700;color:#102c24;">' + totalPrice + '</span>\
          </div>\
          <div style="font-size:13px;color:#777;margin-bottom:16px;">Frakt og avgifter kalkuleres i kassen</div>\
          <a href="/cart" style="display:flex;align-items:center;justify-content:center;height:48px;background:#102c24;color:#fff;border-radius:8px;font-family:\'Plus Jakarta Sans\',sans-serif;font-size:15px;font-weight:600;text-decoration:none;transition:background 0.2s;">Se handlekurv</a>\
        </div>\
      ';

      // Re-bind close button
      draw.querySelector('#loopr-cart-drawer-close').addEventListener('click', closeDrawer);

      // Bind quantity buttons
      draw.querySelectorAll('.loopr-drawer-qty').forEach(function(qBtn) {
        qBtn.addEventListener('click', function() {
          var key = this.getAttribute('data-key');
          var action = this.getAttribute('data-action');
          var currentQty = parseInt(this.closest('.loopr-drawer-item').querySelector('span').textContent);
          var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
          if (newQty < 0) newQty = 0;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            // Refresh drawer
            looprOpenCartDrawer();
            // Update header count
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
              document.querySelectorAll('.loopr-navbar__cart-count').forEach(function(el) { el.textContent = c.item_count; });
            });
          });
        });
      });

      // Bind remove buttons
      draw.querySelectorAll('.loopr-drawer-remove').forEach(function(rBtn) {
        rBtn.addEventListener('click', function() {
          var key = this.getAttribute('data-key');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            looprOpenCartDrawer();
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
              document.querySelectorAll('.loopr-navbar__cart-count').forEach(function(el) { el.textContent = c.item_count; });
            });
          });
        });
      });
    });
}

function addCartButtons() {
  document.querySelectorAll('.product-card').forEach(function(card) {
    if (card.querySelector('.loopr-cart-btn')) return;

    var form = card.querySelector('.shopify-product-form');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    var variantId = variantInput.value;

    var btn = document.createElement('button');
    btn.className = 'loopr-cart-btn';
    btn.setAttribute('aria-label', 'Legg til i handlekurv');
    btn.setAttribute('data-variant-id', variantId);
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var id = this.getAttribute('data-variant-id');
      btn.classList.add('loopr-cart-btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(addedItem) {
        btn.classList.remove('loopr-cart-btn--loading');
        btn.classList.add('loopr-cart-btn--added');
        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';

        // Update cart count in header
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var counts = document.querySelectorAll('.loopr-navbar__cart-count');
            counts.forEach(function(el) { el.textContent = cart.item_count; });
          });

        // Render the added item in the cart notification
        var cartNotif = document.querySelector('cart-notification');
        if (cartNotif) {
          cartNotif.item = addedItem;
          cartNotif._render();
        }

        // Open cart drawer
        looprOpenCartDrawer();

        // Revert button icon after 2s (drawer stays open)
        setTimeout(function() {
          btn.classList.remove('loopr-cart-btn--added');
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('loopr-cart-btn--loading');
      });
    });

    var imageArea = card.querySelector('.product-card__details');
    if (imageArea) {
      imageArea.style.position = 'relative';
      imageArea.appendChild(btn);
    }
  });
}

function handleFilterState() {
  var carousel = document.querySelector('.loopr-carousel-section');
  if (!carousel) return;

  var params = new URLSearchParams(window.location.search);
  var hasFilters = false;
  params.forEach(function(value, key) {
    if (key.startsWith('filter.')) hasFilters = true;
  });

  var activeFilters = document.querySelectorAll('.collection__filters-active__filter:not(.collection__filters-active__filter--clear)');
  if (activeFilters.length > 0) hasFilters = true;

  if (hasFilters) {
    var vatInline = document.getElementById('loopr-vat-inline');
    var vatWrapper = document.querySelector('.loopr-vat-bar-wrapper');
    var vatBar = document.querySelector('.loopr-vat-bar');
    if (vatInline && vatBar && vatWrapper) {
      while (vatInline.firstChild) {
        vatBar.appendChild(vatInline.firstChild);
      }
      vatWrapper.style.display = '';
      vatBar.style.justifyContent = 'flex-end';
      vatBar.style.gap = '12px';
    }
    carousel.style.display = 'none';
  } else {
    carousel.style.display = '';
    var vatBar2 = document.querySelector('.loopr-vat-bar');
    var vatInline2 = document.getElementById('loopr-vat-inline');
    var vatWrapper2 = document.querySelector('.loopr-vat-bar-wrapper');
    if (vatInline2 && vatBar2 && vatWrapper2) {
      while (vatBar2.firstChild) {
        vatInline2.appendChild(vatBar2.firstChild);
      }
      vatWrapper2.style.display = 'none';
    }
    var existing = document.getElementById('loopr-filter-breadcrumb');
    if (existing) existing.remove();
  }
}

function initCartErrorHandling() {
  if (!window.location.pathname.includes('/cart')) return;

  var errorObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        checkForErrors(node);
      });

      // Also check for text/style changes on existing elements
      if (mutation.type === 'attributes' || mutation.type === 'characterData') {
        checkForErrors(mutation.target);
      }
    });
  });

  errorObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
    characterData: true
  });

  // Also intercept the checkout button click to watch for errors
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[name="checkout"], .cart__checkout-btn, [type="submit"]');
    if (!btn || !window.location.pathname.includes('/cart')) return;

    // Check for errors after a short delay (give the app time to inject the error)
    setTimeout(function() { scanForVisibleErrors(); }, 500);
    setTimeout(function() { scanForVisibleErrors(); }, 1500);
    setTimeout(function() { scanForVisibleErrors(); }, 3000);
  });
}

function checkForErrors(node) {
  if (!node || !node.classList) return;

  var isError = node.classList.contains('order-slots-error') ||
    node.classList.contains('alert') ||
    node.classList.contains('errors') ||
    node.classList.contains('error') ||
    node.classList.contains('cart__error') ||
    node.getAttribute('role') === 'alert';

  var innerError = node.querySelector && node.querySelector('.order-slots-error, .alert, .errors, .error, .cart__error, [role="alert"]');

  if (isError || innerError) {
    var errorEl = isError ? node : innerError;
    var errorText = errorEl.textContent.trim();
    if (errorText && errorText.length > 2) {
      handleCartError(errorEl, errorText);
    }
  }
}

function scanForVisibleErrors() {
  document.querySelectorAll('.order-slots-error, .alert, .errors, .cart__error, [role="alert"]').forEach(function(el) {
    var text = el.textContent.trim();
    var isVisible = el.offsetParent !== null || getComputedStyle(el).display !== 'none';
    if (text && text.length > 2 && isVisible) {
      handleCartError(el, text);
    }
  });
}

function handleCartError(errorEl, errorText) {
  // Show toast notification
  showLooprToast(errorText);

  // Scroll to the error element
  if (errorEl && errorEl.getBoundingClientRect) {
    var rect = errorEl.getBoundingClientRect();
    var isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!isInView) {
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

function showLooprToast(message) {
  // Don't show duplicate toasts
  var existing = document.querySelectorAll('.loopr-toast');
  for (var i = 0; i < existing.length; i++) {
    if (existing[i].textContent.trim() === message.trim()) return;
  }

  var toast = document.createElement('div');
  toast.className = 'loopr-toast';
  toast.style.cssText = '\
    position:fixed;top:20px;right:20px;z-index:10000;\
    max-width:400px;width:calc(100% - 40px);\
    background:#102c24;color:#fff;\
    padding:16px 20px;border-radius:12px;\
    font-family:"Plus Jakarta Sans",sans-serif;\
    font-size:14px;font-weight:500;line-height:1.4;\
    box-shadow:0 4px 20px rgba(0,0,0,0.2);\
    display:flex;align-items:flex-start;gap:12px;\
    opacity:0;transform:translateY(-10px);\
    transition:opacity 0.3s ease,transform 0.3s ease;\
  ';

  toast.innerHTML = '\
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff6b6b" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;margin-top:1px;">\
      <circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>\
    </svg>\
    <span style="flex:1;">' + message + '</span>\
    <button style="background:none;border:none;cursor:pointer;padding:0;flex-shrink:0;" onclick="this.parentElement.remove()">\
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>\
    </button>\
  ';

  document.body.appendChild(toast);

  requestAnimationFrame(function() {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  // Auto-remove after 6 seconds
  setTimeout(function() {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-10px)';
    setTimeout(function() { toast.remove(); }, 300);
  }, 6000);
}

function looprUpdateCartSummary() {
  fetch('/cart.js')
    .then(function(r) {
      return r.json();
    })
    .then(function(cart) {
      window.looprLastCartTotal = cart.total_price;

      // Update header cart count
      var counts = document.querySelectorAll('.loopr-navbar__cart-count');
      counts.forEach(function(el) { el.textContent = cart.item_count; });

      // Update Sammendrag total
      looprApplyCartTotal();

      // Update cart title count
      var itemsCount = document.querySelector('items-count');
      if (itemsCount) itemsCount.textContent = cart.item_count;
      var infoContent = document.querySelector('info-content');
      if (infoContent) infoContent.textContent = cart.item_count === 1 ? 'vare' : 'varer';
    })
    .catch(function(err) {
      console.log('Cart summary update skipped:', err.message);
    });
}

function looprApplyCartTotal() {
  if (!window.looprLastCartTotal && window.looprLastCartTotal !== 0) return;

  var mode = localStorage.getItem('loopr-pricing') || 'b2b';
  var total = window.looprLastCartTotal / 100;
  if (mode === 'b2c') {
    total = total * 1.25;
  }

  var formatted = Math.round(total).toLocaleString('nb-NO') + ' NOK';
  var cartTotalEl = document.querySelector('cart-total.money');
  if (cartTotalEl) {
    var dualPrice = cartTotalEl.querySelector('.dualPrice');
    if (dualPrice) {
      dualPrice.textContent = formatted;
    } else {
      cartTotalEl.textContent = formatted;
    }
  }
}

function initProductPageCartButton() {
  var form = document.querySelector('.js-product-form, form[action="/cart/add"]');
  if (!form) return;
  if (form.dataset.looprBound) return;
  form.dataset.looprBound = 'true';

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    var id = variantInput.value;

    var qtyInput = form.querySelector('input[name="quantity"], [name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    var submitBtn = form.querySelector('[type="submit"], .js-product-add');
    if (submitBtn) submitBtn.classList.add('loopr-cart-btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (submitBtn) submitBtn.classList.remove('loopr-cart-btn--loading');

      // Update header cart count
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var counts = document.querySelectorAll('.loopr-navbar__cart-count');
          counts.forEach(function(el) { el.textContent = cart.item_count; });
        });

      // Open our custom drawer
      looprOpenCartDrawer();
    })
    .catch(function() {
      if (submitBtn) submitBtn.classList.remove('loopr-cart-btn--loading');
    });
  }, true);
}

// ── Run everything ────────────────────────────
function runAll() {
  cacheDimensionValues(); // cache BEFORE replacing  
  initPriceToggle();
  addColorDots();
  addFilterSearch();
  replaceDimensionFilters();
  enhanceBrandFilter();
  enhanceCategoryFilter();
  addCartButtons();
  handleFilterState();
}

// Unified fetch interceptor
const originalFetch = window.fetch;

window.fetch = function(...args) {
  return originalFetch.apply(this, args).then(response => {
    const url = args[0]?.toString() || '';
    // Re-run enhancements for collection/search page updates (skip cart API calls)
    if ((url.includes('collections') || url.includes('search') || url.includes('filter'))
        && !url.includes('/cart')) {
      clearTimeout(window.looprFetchTimer);
      window.looprFetchTimer = setTimeout(runAll, 1000);
    }
    return response;
  });
};

document.addEventListener('DOMContentLoaded', function() {
  runAll();
  initSearchPageEmptyState();
  initCartErrorHandling();
  initProductPageCartButton();

  // Cart page enhancements
  if (window.location.pathname.includes('/cart')) {
    // Initial sync on page load
    looprUpdateCartSummary();

    // Single debounced observer for cart item changes
    var cartUpdateTimer = null;
    var cartItems = document.querySelector('cart-items, .cart__items');
    if (cartItems) {
      new MutationObserver(function() {
        clearTimeout(cartUpdateTimer);
        cartUpdateTimer = setTimeout(looprUpdateCartSummary, 3000);
      }).observe(cartItems, { childList: true, subtree: true });
    }

    // VAT toggle updates total immediately
    var track = document.getElementById('loopr-toggle-track');
    if (track) {
      track.addEventListener('click', function() {
        setTimeout(looprApplyCartTotal, 50);
      });
    }
  }
});